/***
 * Created on 2025/3/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import no_device_svg from "../../static/img/illustration/illustration-no-devices.svg";
import {useTranslation} from "react-i18next";

function DeviceEmptyContent(props) {
    const { t } = useTranslation();

    return (
        <div className="flexbox-tbody overlay-scroll os-host-flexbox">
            <div className="no-data-screen">
                <div className="no-data-info">
                    <div className="no-data-img"><img src={no_device_svg} alt=""/></div>
                    <div className="no-data-desc">
                        <div className="desc-title">
                            {t('@No devices have been registered yet. Registered devices will display here once any QIDs start making requests.@')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeviceEmptyContent;